export default __webpack_public_path__ + "static/media/21_3_2.b57b1ade.png";